<template>
  <div class="left-column" :class="api.state.sidebar.opened ? 'is-action' : ''">
    <div class="menuTitle leave">
      安吉智慧厕所
    </div>
    <el-menu
      style="margin-top: 60px;font-size:1.1vw;"
      ref="menu"
      default-active="2"
      class="el-menu-vertical-demo"
      :unique-opened="true"
      :router="true"
      text-color="#fff"
      active-text-color="#ffd04b"
      :default-openeds="[this.$route.name]"
    >
      <el-menu-item index="home"  v-if="global.power('index')">驾驶舱大屏</el-menu-item>
      <!--      <el-submenu index="1-1" v-if="global.power('drainage')">-->
      <!--        <template slot="title">真空智慧厕所</template>-->
      <!--        <el-menu-item index="vacuumStationInfo" :class="{ choose_From: $route.path === '/vacuumStationInfo' }">真空泵站管理-->
      <!--        </el-menu-item>-->
      <!--        <el-menu-item index="collectWellInfo" :class="{ choose_From: $route.path === '/collectWellInfo' }">收集井管理-->
      <!--        </el-menu-item>-->
      <!--        <el-menu-item index="collectWellDetail" :class="{ choose_From: $route.path === '/collectWellDetail' }">收集井数据信息-->
      <!--        </el-menu-item>-->
      <!--      </el-submenu>-->
      <el-submenu index="2-1" v-if="global.power('toilet')">
        <template slot="title">厕所监管</template>
        <el-menu-item index="toiletMap" v-if="global.power('toilet.map')"
                      :class="{ choose_From: $route.path === '/toiletMap' }">智慧厕所地图
        </el-menu-item>
        <el-menu-item index="toiletInfo" v-if="global.power('toilet.list')"
                      :class="{ choose_From: $route.path === '/toiletInfo' }">智慧厕所列表
        </el-menu-item>
        <el-menu-item index="toiletDetail" v-if="global.power('toilet.detail')"
                      :class="{ choose_From: $route.path === '/toiletDetail' }">智慧厕所详情
        </el-menu-item>
        <el-menu-item index="toiletDetail2" v-if="global.power('toilet.detail')"
                      :class="{ choose_From: $route.path === '/toiletDetail2' }">真空厕所详情
        </el-menu-item>
        <el-menu-item index="toiletPv" v-if="global.power('toilet.detail')"
                      :class="{ choose_From: $route.path === '/toiletPv' }">光伏厕所详情
        </el-menu-item>

      </el-submenu>
      <el-submenu index="3-1">
                <el-menu-item index="company"
                      :class="{ choose_From: $route.path === '/company' || $route.path ==='/companyDetails' }"
                      v-if="global.power('operation/company') === true">运维公司管理
        </el-menu-item>
        <template slot="title">运维管理</template>
        <el-menu-item index="workOrder" v-if="global.power('operation/workorder')"
                      :class="{ choose_From: $route.path === '/workOrder' || $route.path ==='/workOrderDetails'}">工单管理
        </el-menu-item>
      </el-submenu>
      <el-submenu index="4-1">
        <template slot="title">报表管理</template>
        <!-- <el-menu-item index="workorderSummaryReport"
                      :class="{ choose_From: $route.path === '/workorderSummaryReport' }">真空厕所运行数据
        </el-menu-item> -->
        <el-menu-item index="toiletAnalysis" v-if="global.power('toilet.analysis')" :class="{ choose_From: $route.path === '/toiletAnalysis' }">智慧厕所分析
        </el-menu-item>

        <el-menu-item index="inspection" :class="{ choose_From: $route.path === '/inspection' }">智慧厕所运行报表
        </el-menu-item>
        <el-menu-item index="workorderLag" :class="{ choose_From: $route.path === '/workorderLag' }">真空厕所降碳报表
        </el-menu-item>

        <el-menu-item index="perationoPersonnel" :class="{ choose_From: $route.path === '/perationoPersonnel' }">
          运维工作量化考核
        </el-menu-item>
        <el-menu-item index="toileUseThePaper" :class="{ choose_From: $route.path === '/toileUseThePaper' }">出纸机用纸报表
        </el-menu-item>
        <el-menu-item index="vacuumDrainageReport" :class="{ choose_From: $route.path === '/vacuumDrainageReport' }">
          意见反馈报表
        </el-menu-item>
      </el-submenu>
      <el-submenu index="5-1" v-if="global.power('usermgr') === true">
        <template slot="title">系统管理</template>
        <el-menu-item index="userDetails" v-if="global.power('usermgr')"
                      :class="{ choose_From: $route.path === '/userDetails'}">用户管理
        </el-menu-item>
        <el-menu-item index="user" v-if="global.power('user.role')" :class="{ choose_From: $route.path === '/user'}">
          角色管理
        </el-menu-item>
        <el-menu-item index="personalCenter" :class="{ choose_From: $route.path === '/personalCenter'}">个人中心
        </el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "left",
  data() {
    return {};
  },
  methods: {},
  mounted() {
  },
  created: function () {
  }

};
</script>
<style scoped>
.left-column {
  width: 280px;
  height: 100%;
  position: fixed;
  bottom: 0;
  top: 0;
  background: #001529;
  background: url(../../img/baseImg/theme_bg1.png) no-repeat;
  background-size: 100% 100%;
  background-color: #011024;
  transition: 580ms 0s;
}

.left-column /deep/ .el-menu {
  border: none;
  text-align: left;
  background-color: transparent;
}

.left-column /deep/ .el-menu-item.is-active {
  background-color: #063762;
}

.left-column /deep/ .el-submenu__title:hover {
  background-color: transparent !important;
}

.left-column /deep/ .el-submenu .el-menu-item {
  background-color: #0b1117;
  color: #fff !important;
  font-size: 20px;
}
.left-column /deep/ .el-submenu__title{
  font-size: 1.1vw;
}

.choose_From {
  background-color: #063762 !important;
}

.left-column /deep/ .el-menu-item:hover {
  background-color: #063762;
}

.menuTitle {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  font-size: 21px;
  text-align: center;
  font-weight: bold;
  line-height: 60px;
  height: 60px;
  border-bottom: 1px solid #d5d5d5;
  color: white;
  background-color: #001529;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/left.vue